import { memo } from 'react';
import { Monitor, Smartphone } from 'lucide-react';

const BuilderPreview = memo(({ site, activePageData, activeHtml, previewMode, setPreviewMode, fetchSite, t }) => (
  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: '#0a0908' }}>
    {/* Browser chrome */}
    <div style={{ display: 'flex', alignItems: 'center', padding: '8px 14px', background: '#0f0e0c', borderBottom: '1px solid rgba(242,239,233,0.04)', flexShrink: 0 }}>
      <div style={{ display: 'flex', gap: '5px', marginRight: '10px' }}>
        <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#ff5f57' }} />
        <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#febd2e' }} />
        <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#28c840' }} />
      </div>
      <span style={{ fontFamily: 'var(--sans)', fontSize: '11px', color: 'rgba(242,239,233,.15)', flex: 1 }}>
        {site.business_name?.toLowerCase().replace(/\s+/g, '')}.goldenhour.build{activePageData && !activePageData.is_home ? `/${activePageData.slug}` : ''}
      </span>
      <div style={{ display: 'flex', gap: '2px', background: 'rgba(242,239,233,0.04)', padding: '3px', borderRadius: '8px' }}>
        <button onClick={() => setPreviewMode('desktop')} data-testid="preview-desktop" style={{
          padding: '4px 10px', background: previewMode === 'desktop' ? 'rgba(242,239,233,0.08)' : 'transparent',
          border: 'none', cursor: 'pointer', color: previewMode === 'desktop' ? 'var(--gold)' : 'rgba(242,239,233,0.2)',
          display: 'flex', alignItems: 'center', borderRadius: '6px', transition: 'all .15s',
        }}><Monitor size={13} /></button>
        <button onClick={() => setPreviewMode('mobile')} data-testid="preview-mobile" style={{
          padding: '4px 10px', background: previewMode === 'mobile' ? 'rgba(242,239,233,0.08)' : 'transparent',
          border: 'none', cursor: 'pointer', color: previewMode === 'mobile' ? 'var(--gold)' : 'rgba(242,239,233,0.2)',
          display: 'flex', alignItems: 'center', borderRadius: '6px', transition: 'all .15s',
        }}><Smartphone size={13} /></button>
      </div>
    </div>

    {/* Preview area */}
    <div style={{ flex: 1, display: 'flex', justifyContent: 'center', background: previewMode === 'mobile' ? '#080807' : 'transparent', transition: 'background .3s' }}>
      <div style={{ width: previewMode === 'mobile' ? '375px' : '100%', height: '100%', transition: 'width .3s', boxShadow: previewMode === 'mobile' ? '0 0 40px rgba(0,0,0,0.5)' : 'none' }}>
        {activeHtml ? (
          <iframe
            srcDoc={activeHtml + '<script>document.addEventListener("click",function(e){var a=e.target.closest("a");if(a){e.preventDefault();e.stopPropagation();var h=a.getAttribute("href");if(h&&h.startsWith("#")&&h.length>1){var t=document.querySelector(h);if(t)t.scrollIntoView({behavior:"smooth"});}return false;}},true);document.addEventListener("submit",function(e){e.preventDefault();},true);window.open=function(){return null;};<\/script>'}
            title="Preview"
            sandbox="allow-scripts allow-same-origin"
            style={{ width: '100%', height: '100%', border: 'none' }}
            data-testid="builder-preview-iframe"
          />
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: '16px' }}>
            <div style={{ width: '60%', maxWidth: '400px' }}>
              <div style={{ width: '100%', height: '8px', background: 'rgba(201,168,76,0.08)', borderRadius: '4px', marginBottom: '12px', animation: 'pulse 1.5s ease-in-out infinite' }} />
              <div style={{ width: '80%', height: '6px', background: 'rgba(201,168,76,0.05)', borderRadius: '4px', marginBottom: '8px', animation: 'pulse 1.5s ease-in-out infinite', animationDelay: '0.2s' }} />
              <div style={{ width: '60%', height: '6px', background: 'rgba(201,168,76,0.05)', borderRadius: '4px', animation: 'pulse 1.5s ease-in-out infinite', animationDelay: '0.4s' }} />
            </div>
            <p style={{ color: 'var(--muted)', fontFamily: 'var(--sans)', fontSize: '13px' }}>Loading your site...</p>
            <button onClick={fetchSite} data-testid="preview-retry" style={{ padding: '7px 18px', fontFamily: 'var(--sans)', fontSize: '11px', color: 'var(--gold)', background: 'rgba(201,168,76,0.06)', border: '1px solid rgba(201,168,76,0.12)', cursor: 'pointer', borderRadius: '8px' }}>
              Retry
            </button>
            <style>{`@keyframes pulse{0%,100%{opacity:0.4}50%{opacity:1}}`}</style>
          </div>
        )}
      </div>
    </div>
  </div>
));

BuilderPreview.displayName = 'BuilderPreview';
export default BuilderPreview;
